var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInboxText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1274_2744",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1274_2744)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 10.2083H13.3333C13.5694 10.2083 13.7674 10.1285 13.9271 9.96875C14.0868 9.80903 14.1667 9.61111 14.1667 9.375C14.1667 9.13889 14.0868 8.94097 13.9271 8.78125C13.7674 8.62153 13.5694 8.54167 13.3333 8.54167H6.66667C6.43056 8.54167 6.23264 8.62153 6.07292 8.78125C5.91319 8.94097 5.83333 9.13889 5.83333 9.375C5.83333 9.61111 5.91319 9.80903 6.07292 9.96875C6.23264 10.1285 6.43056 10.2083 6.66667 10.2083ZM6.66667 7.29167H13.3333C13.5694 7.29167 13.7674 7.21181 13.9271 7.05208C14.0868 6.89236 14.1667 6.69444 14.1667 6.45833C14.1667 6.22222 14.0868 6.02431 13.9271 5.86458C13.7674 5.70486 13.5694 5.625 13.3333 5.625H6.66667C6.43056 5.625 6.23264 5.70486 6.07292 5.86458C5.91319 6.02431 5.83333 6.22222 5.83333 6.45833C5.83333 6.69444 5.91319 6.89236 6.07292 7.05208C6.23264 7.21181 6.43056 7.29167 6.66667 7.29167ZM4.16667 17.5C3.70833 17.5 3.31597 17.3368 2.98958 17.0104C2.66319 16.684 2.5 16.2917 2.5 15.8333V4.16667C2.5 3.70833 2.66319 3.31597 2.98958 2.98958C3.31597 2.66319 3.70833 2.5 4.16667 2.5H15.8333C16.2917 2.5 16.684 2.66319 17.0104 2.98958C17.3368 3.31597 17.5 3.70833 17.5 4.16667V15.8333C17.5 16.2917 17.3368 16.684 17.0104 17.0104C16.684 17.3368 16.2917 17.5 15.8333 17.5H4.16667ZM10 13.3333C10.4444 13.3333 10.8542 13.2188 11.2292 12.9896C11.6042 12.7604 11.9097 12.4583 12.1458 12.0833C12.2292 11.9583 12.3333 11.8576 12.4583 11.7812C12.5833 11.7049 12.7222 11.6667 12.875 11.6667H15.8333V4.16667H4.16667V11.6667H7.125C7.27778 11.6667 7.41667 11.7049 7.54167 11.7812C7.66667 11.8576 7.77083 11.9583 7.85417 12.0833C8.09028 12.4583 8.39583 12.7604 8.77083 12.9896C9.14583 13.2188 9.55556 13.3333 10 13.3333Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInboxText);
export default __webpack_public_path__ + "static/media/icon_inbox_text.1a33b9bdb21a003f04cd114fa4845260.svg";
export { ForwardRef as ReactComponent };